import React, { useRef, useState, useEffect } from 'react';
import useSWR from 'swr';
import axios from 'axios';
import ListaGrupos from './ListaGrupos';
import HeroBanner from './HeroBanner';

const backendURL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

const fetcher = (url) => axios.get(url).then((res) => res.data);

function ListaGruposPage() {
  const seccionesRefs = useRef({});
  const [haVotado, setHaVotado] = useState(false);

  const { data: grupos, error, mutate } = useSWR(`${backendURL}/api/grupos`, fetcher, {
    refreshInterval: 3000,
  });

  useEffect(() => {
    // Verificar el estado de votación en localStorage
    const votado = localStorage.getItem('haVotado') === 'true';
    setHaVotado(votado);
  }, []);

  const votar = async (id) => {
    try {
      await axios.post(`${backendURL}/api/votar/${id}`);
      localStorage.setItem('haVotado', 'true'); // Guardar el estado en localStorage
      setHaVotado(true); // Actualizar el estado local
      mutate(); // Refrescar datos después de votar
    } catch (err) {
      console.error('Error al votar:', err);
    }
  };

  if (error) return <p>Error al cargar los datos</p>;
  if (!grupos) return <p>Cargando...</p>;
  if (!grupos.length) return <p>No hay grupos disponibles</p>;

  return (
    <div>
      <HeroBanner />
      <h1 className='textoIntro'>Votá por la mejor utilería del carnaval</h1>
      <ListaGrupos grupos={grupos} votar={votar} haVotado={haVotado} seccionesRefs={seccionesRefs} />
    </div>
  );
}

export default ListaGruposPage;
